import { SYSTEM_DATA_FIELDS_IDENTIFIERS } from 'src/constants/dynamicFields';
import { auth as useAuthStore } from 'src/store/auth';
import { clients as useClientsStore } from 'src/store/clients';
import { dataFields as useDataFieldsStore } from 'src/store/dataFields';
import { logEvent } from 'src/utils/LogEvent';
import { computed } from 'vue';

// eslint-disable-next-line import/prefer-default-export
export function useSignature() {
  const auth = useAuthStore();
  const clients = useClientsStore();
  const dataFields = useDataFieldsStore();

  const professionalCredentialsDataField = computed(() => {
    return dataFields.staffMemberSystemDataFields.find(
      ({ identifier }) => identifier === SYSTEM_DATA_FIELDS_IDENTIFIERS.PROFESSIONAL_CREDENTIALS,
    );
  });

  async function getStaffInfoForSignature(userName, userId, includeProfessionalCredentials = false) {
    const staffInfo = {
      userName,
    };

    if ((!auth.useLegalNameInSignature && !includeProfessionalCredentials) || !userId) {
      return staffInfo;
    }

    try {
      const staffMember = await clients.getStaffMemberByUser(userId);
      staffInfo.userName = staffMember?.clientName || userName;

      if (
        includeProfessionalCredentials
        && professionalCredentialsDataField.value
        && staffMember?.customData?.[professionalCredentialsDataField.value.id] !== undefined
      ) {
        const professionalCredentialsValue = staffMember.customData[professionalCredentialsDataField.value.id];

        if (Array.isArray(professionalCredentialsValue) && professionalCredentialsValue.length) {
          staffInfo.professionalCredentials = professionalCredentialsValue;
        } else if (!Array.isArray(professionalCredentialsValue) && professionalCredentialsValue) {
          staffInfo.professionalCredentials = [professionalCredentialsValue];
        }
      }
    } catch (err) {
      console.error(`Error getting staff member: ${err.message}`);
      logEvent(err);
    }

    return staffInfo;
  }

  return {
    getStaffInfoForSignature,
  };
}
